//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    dealName: {
      type: String,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
    subcategory: {
      type: Object,
      required: true,
    },
  },
  computed: {
    query() {
      const params = this.$route.fullPath.split('?');
      if (params.length > 1) {
        return `?${params[1].split('#')[0]}`;
      }
      return '';
    },
    crumbs() {
      const crumbArray = [];

      crumbArray.push({
        ...this.group,
        href: `/${this.group.values[0].slug}/`,
      });

      crumbArray.push({
        ...this.category,
        href: `/${this.group.values[0].slug}/${this.category.values[0].slug}/`,
      });

      crumbArray.push({
        ...this.subcategory,
        href: `/${this.group.values[0].slug}/${this.category.values[0].slug}/${this.subcategory.values[0].slug}/`,
      });

      crumbArray.push({
        name: this.dealName,
      });

      return crumbArray;
    },
  },
};
